import React from 'react';
import { useDispatch } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';
import { loginWithGoogle } from '../../store/slices/authSlice';

const GoogleLoginButton = () => {
  const dispatch = useDispatch();

  const handleSuccess = (credentialResponse) => {
    dispatch(loginWithGoogle(credentialResponse.credential));
  };

  const handleError = () => {};

  return (
    <div className='flex justify-center my-5'>
      <GoogleLogin onSuccess={handleSuccess} onError={handleError} />
    </div>
  );
};

export default GoogleLoginButton;
